import BaseViz from './BaseViz'
import PyramidChartChart from '../charts/PyramidChartChart'
import PyramidChartDataController from '../viz_behaviors/PyramidChartDataController'
export default class PyramidChartViz extends BaseViz {
  static defaultConfig = {
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical', 'single'],
      },
    },
    AxisHelper: {
      x: {
        trimThreshold: {
          nonEditable: true,
          exposed: false,
        },
        valueFormat: {
          nonEditable: true,
          exposed: false,
        },
        unit: {
          nonEditable: true,
          exposed: false,
        },
        scale: {
          nonEditable: true,
        },
        tickMatchData: {
          nonEditable: true,
          exposed: false,
        },
      },
    },
  }
  static chartClass = PyramidChartChart
  static dataControllerClass = PyramidChartDataController
}
